import React from 'react'
import { Box } from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';

function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
    }

    const columns = [

      { field: 'EnquiryNo', headerName: 'No', editable: false, sortable: false, minWidth: 100 }, 
      { field: 'EnquiryDate', headerName: 'Date', editable: false, sortable: false, minWidth: 100}, 
      { field: 'Customer', headerName: 'Customer', editable: false, sortable: false, flex: 1, minWidth: 100 }, 
      { field: 'VehicleModel', headerName: 'Vehicle Model', editable: false, sortable: false, flex: 1, minWidth: 100 }, 
      { field: 'VehicleNumber', headerName: 'Vehicle Number', editable: false, sortable: false, minWidth: 100}, 
      { field: 'enstatus', headerName: 'Status', editable: false, sortable: false, minWidth: 100}, 
      { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 110, 
        renderCell: (params) => { 
          return ( 
            <ActionButtons title='Convert To Estimate' status={params.row.enstatus==='Enquiry'?true:false} page='add_estimate'/>
          );
         } 
      } 
      ];
       
      const rows = [
      
      { EnquiryNo: 1231, EnquiryDate: '01-02-2023', Customer: 'Oliver Jake Jack Connor', VehicleModel: 'BmwToyota Fortune', VehicleNumber:'KZ66 ZYT', enstatus:'Enquiry' }, 
      { EnquiryNo: 1232, EnquiryDate: '01-02-2023', Customer: 'John Fitzgerald Kennedy', VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate' },
      { EnquiryNo: 1233, EnquiryDate: '01-02-2023', Customer: 'Alexander Anthony Benjamin', VehicleModel: 'Hyundai Creta', VehicleNumber:'PZ65 PWO', enstatus:'Enquiry' },  
      { EnquiryNo: 1234, EnquiryDate: '01-02-2023', Customer: 'Liam John Mason Robert', VehicleModel: 'Lamborghini', VehicleNumber:'HZ13 WDD', enstatus:'Enquiry' }, 
      { EnquiryNo: 1235, EnquiryDate: '01-02-2023', Customer: 'Christopher Dominic Gabriel', VehicleModel: 'Mitsubishi', VehicleNumber:'PZ65 BYV', enstatus:'Estimate' },
      ];
      
    
function AllEnquiry({rows, columns}) {
  return (
    <Box sx={dataGridStyle.root}>
          <DataGrid
            columnHeaderHeight={42}
            rowHeight={40}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.EnquiryNo}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
  )
}

export default AllEnquiry